export const MONTHS_IN_YEAR = 12;
export const ONE_UNIT_CENTS_COUNT = 100;
